<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card>
        <b-row>
          <b-col sm="6" md="4" xl="4">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline"> Fecha inicio </label>
              <flat-pickr id="start_date" v-model="startDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4" xl="4">
            <b-form-group>
              <label for="endDate" class="fs-5 fw-semibold d-inline"> Fecha Final </label>
              <flat-pickr id="endDate" v-model="endDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4" xl="4">
            <b-form-group label="Tienda" label-for="storeOrigin">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                :reduce="(locals) => locals.id"
                input-id="storeOrigin"
                v-model="local"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4" xl="4">
            <b-form-group label="Orden" label-for="typeventa">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="orderBy"
                label="name"
                :reduce="(orderBy) => orderBy.value"
                input-id="typeventa"
                v-model="reportType"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4" xl="4">
            <b-form-group label="Acciones" label-for="actions" class="text-05">
              <div class="d-flex justify-content-around" id="actions">
                <b-button
                  @click.prevent="searchReport"
                  class="w-100"
                  id="search"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <!-- <feather-icon icon="StarIcon" class="mr-50" /> -->
                  <span class="align-middle">Buscar</span>
                </b-button>
                <b-button
                  @click="exportExcel"
                  class="w-100 ml-2"
                  id="export"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                >
                  <!-- <feather-icon icon="StarIcon" class="mr-50" /> -->
                  <span class="align-middle">Excel</span>
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card no-body class="">
        <b-table
          class="position-relative shadow-md"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <template #cell(precio)="data">
            {{ '$' + data.value }}
          </template>
          <!-- Column: Actions -->
          <!-- <template #cell(actions)="data">
            <b-form-checkbox v-model="data.value" class="vs-checkbox-con" @change="select(data.item, data.value)">
            </b-form-checkbox>
          </template> -->
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { $themeColors } from '@themeConfig'
import flatPickr from 'vue-flatpickr-component'
import productosFilters from './productosFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StoreService from '@/services/StoresService'
import ReportService from '@/services/ReportsService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
const urlBase = process.env.APIURL
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  components: {
    flatPickr,
    productosFilters,
    vSelect
  },
  data() {
    return {
      showLoading: false,
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      totalAmount: 0.0,
      reportType: '',
      records: [],
      fields: [
        //{ key: 'id', label: 'Nº', sortable: false },
        { key: 'originalCode', label: 'Codigo Original', sortable: true },
        { key: 'alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'description', label: 'Descripción', sortable: false },
        { key: 'brandName', label: 'Marca', sortable: true },
        { key: 'vehicleModel', label: 'Vehiculo', sortable: true },
        { key: 'qtySeller', label: 'Stock General', sortable: true }
        // { key: 'precio', label: 'Precio (US$)', sortable: false },
      ],
      locals: [],
      local: null,
      orderBy: [
        {
          id: 1,
          name: 'Mas vendidos',
          value: 'asc'
        },
        {
          id: 2,
          name: 'Menos vendidos',
          value: 'desc'
        }
      ],
      items: [],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.locals = []
      const resp = await StoreService.getStores('',this.$store)
      console.log('resp', resp)
      if (resp) {
        this.locals = resp.stores
        this.locals.unshift({
          id: 0,
          name: 'Todos'
        })
      }
    },
    async searchReport() {
      if (this.local != null && this.reportType != '') {
        let url = ''
        console.log('this.local',this.local)
        if (this.local == 0) {
          url = '?reportType=' + this.reportType
        } else {
          url = '?store=' + this.local + '&reportType=' + this.reportType
        }
        console.log('url', url)
        this.records = []
        const respReport = await ReportService.reportMasMenosVendidos(url, this.$store)
        if (respReport.stocks.length != 0) {
          this.records = respReport.stocks
          this.totalElements = respReport.stocks.length
        }
      }
    },
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    select(item, val) {
      if (val == true) {
        this.items.push(item)
      } else {
        this.items = this.items.filter((elemento) => elemento.id !== item.id)
        // this.items = this.items.filter((item) => item.id != item.id)
      }
      console.log('this.items', this.items)
    },
    async exportExcel() {
      if (this.local != null && this.reportType != '') {
        let url = ''
        console.log('this.local',this.local)
        if (this.local == 0) {
          url = '&reportType=' + this.reportType
        } else {
          url = '?store=' + this.local + '&reportType=' + this.reportType
        }
        console.log('url', url)
        const respReport = await ReportService.reportExportProducts(url, this.$store)
        const url1 = window.URL.createObjectURL(respReport)
        const link = document.createElement('a')
        link.href = url1
        link.setAttribute('download', 'reporte.xlsx')
        document.body.appendChild(link)
        link.click()
      }
    }
  }
}
</script>

<style lang="scss">
.bg-red {
  background-color: #b2a6a6;
  color: #fff;
}
.py-05 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.text-05 {
  font-size: 0.85rem;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
